import React, { useState, useContext } from 'react';
import CityCardComponent from '../CityCard/CityCard';
import { WeatherContext } from '../../core/WeatherDataContext';
import Settings from '../../core/Settings';
import WeatherData from '../../core/WeatherData';

interface CityListProps {
    // Define your component's props here
}

const CityListComponent: React.FC<CityListProps> = () => {
    const context = useContext(WeatherContext);
    const [favoriteCities, setFavoriteCities] = useState<string[]>(Settings.getFavoriteCities());

    const toggleFavorite = (city: string, favorite: boolean) => {
        console.log(city, favorite);
        if (favorite) {
            Settings.addFavoriteCity(city);
        } else {
            Settings.removeFavoriteCity(city);
        }
        setFavoriteCities(Settings.getFavoriteCities());
    };

    const weatherData = context?.value;
    const savedCities = Settings.getSavedCities();

    const cityCards = weatherData
        ?.sort((w1: WeatherData, w2: WeatherData) => {
            const c1fav = favoriteCities.includes(w1.getName());
            const c2fav = favoriteCities.includes(w2.getName());
            if (c1fav && !c2fav) {
                return -1;
            }
            if (!c1fav && c2fav) {
                return 1;
            }
            return w1.getName().localeCompare(w2.getName());
        })
        ?.filter((data: WeatherData) => savedCities.includes(data.getName()))
        .map((weather: WeatherData) => {
            return <CityCardComponent key={weather.getName()} weatherData={weather} isFavorite={favoriteCities.includes(weather.getName())} favoriteCallback={toggleFavorite}></CityCardComponent>
        });

    return (
        <div className="columns is-multiline">
            {cityCards}
        </div>
    );
};

export default CityListComponent;
